<template>
  <table class="desc-info-more">
    <tr v-if="contentInfo.actors.count > 0">
      <th>출연</th>
      <td v-actors="contentInfo.actors"></td>
    </tr>
  </table>
</template>

<script>
import { actors } from '@/common/directives'
export default {
  name: 'ClipDescInfoMore',
  props: ['contentInfo'],
  directives: {
    actors
  }
}
</script>
